import { useEffect } from 'react';
import { pushDatalayer } from 'js/utilities';

export default function ConversionFlowDatalayer({ flow, activeStepId, datalayerData = {} }) {
    useEffect(() => {
        const activeStep = flow?.steps?.find(step => step.id === activeStepId) || null;
        if (!activeStep) return;

        const datalayer = {
            ...datalayerData,
            form_id: `flow-${flow?.flowId}`,
            form_category: flow?.summary?.dataLayer?.form_category,
            form_step: activeStep.last ? 'completed' : `step-${activeStep?.position}`,
            form_type: flow?.summary?.dataLayer?.form_type,
            form_step_name: flow?.summary?.dataLayer?.form_step_name,
            form_cta: flow?.summary?.dataLayer?.form_cta,
            form_name: flow?.summary?.dataLayer?.form_name,
            event: (flow?.summary?.dataLayer?.form_type === 'primair' && activeStep.last) ? 'form' : 'form',
        }

        if (activeStep.last) {
            Object.assign(datalayer, {
                client_email: (flow?.summary?.dataLayer?.email && flow?.summary?.dataLayer?.email !== '') ? flow?.summary?.dataLayer?.email : null,
                submission_id: flow?.summary?.dataLayer?.submission_id,
            });
        }

        Object.assign(datalayer, {
            form_vp: `/form/${flow?.summary?.dataLayer?.form_category}/${flow?.summary?.dataLayer?.form_name ? flow?.summary?.dataLayer?.form_name.toLowerCase().replaceAll(' ', '_') : ''}/${activeStep.last ? 'completed' : `step-${activeStep?.position}`}`,
        });

        pushDatalayer(datalayer);
    }, [activeStepId]);

    return null;
}
